/** HTML element 요소에 특별히 부여할 ID 들 (ref로 가져오기 어려운 케이스) */
export const ElementId = {
    /** 결제수단 상단 */
    PAYMENT_WRAP: 'PAYMENT_WRAP',
    /** 포인트 상단 */
    POINT_SECTION: 'POINT_SECTION',
    /** 환불계좌 상단 */
    REFUND_ACCOUNT_SECTION: 'REFUND_ACCOUNT_SECTION',
    /** 배송지 선택 영역 */
    DELIVERY_SECTION: 'DELIVERY_SECTION',
    /** 후불결제 사용 */
    PAY_LATER_USED: 'PAY_LATER_USED',
    /** 쇼핑라이브 컨텐츠 */
    SHOPPING_LIVE: 'SHOPPING_LIVE',
    /** 카드사 결제할인 */
    CARD_PROMOTION: 'CARD_PROMOTION',
    /** 배송정보변경 > 배송메모 영역 */
    DELIVERY_CHANGE_DELIVERY_MEMO: 'DELIVERY_CHANGE_DELIVERY_MEMO',
} as const

export type ElementIdType = Constant<typeof ElementId>
